// extracted by mini-css-extract-plugin
export default {"swapsHistory":"yU8224byjGxIAA1cVRlv8w=="};